var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBlackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66666 4.16674H2.99999C2.64637 4.16674 2.30723 4.30721 2.05718 4.55726C1.80713 4.80731 1.66666 5.14645 1.66666 5.50007V11.5001C1.66666 11.8537 1.80713 12.1928 2.05718 12.4429C2.30723 12.6929 2.64637 12.8334 2.99999 12.8334H8.99999C9.35361 12.8334 9.69275 12.6929 9.9428 12.4429C10.1928 12.1928 10.3333 11.8537 10.3333 11.5001V10.8334M9.66666 2.8334L11.6667 4.8334M12.59 3.89007C12.8526 3.62751 13.0001 3.27139 13.0001 2.90007C13.0001 2.52875 12.8526 2.17264 12.59 1.91007C12.3274 1.64751 11.9713 1.5 11.6 1.5C11.2287 1.5 10.8726 1.64751 10.61 1.91007L4.99999 7.50007V9.50007H6.99999L12.59 3.89007Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlackIcon);
export default __webpack_public_path__ + "static/media/edit-black-icon.ae7ef7f934b6ecb7b4ae0ad429e82786.svg";
export { ForwardRef as ReactComponent };